export default "__VITE_ASSET__oTelagJB__"